import WorkspaceTaskDetailView from "../components/Workspace/TaskDetail/WorkspaceTaskDetail";

export default function WorkspaceTaskDetail() {
  return <WorkspaceTaskDetailView />;
}
